import Head from "next/head";
import Image from "next/image";

export async function getStaticProps(context) {
    return {
        props: {}, // will be passed to the page component as props
    };
}

const Work = props => {
    return (
        <>
            <Head>
                <title>Works | New Technology in Software Industry</title>
                <meta
                    name="description"
                    content="More than 20 years of experience in developing large-scale enterprise software solutions both locally and globally. Extensive experience in developing complex e-Service solutions for the government of Bangladesh with nationwide implementation."
                />
            </Head>

            <div className="w-full pt-9 md:pt-28" id="Augmentation">
                <div className="grid mid-home-column">
                    <div className="pb-9 md:pb-20 items-center flex flex-col mx-5">
                        <h2 className="pb-1 text-black font-headline break-words text-center font-extrabold text-4xl">
                            Team Augmentation
                        </h2>
                        <p className="text-center break-words font-body text-xl font-normal text-gray-600">
                            Scalable and agile teams, reduced overhead
                        </p>
                    </div>
                    <div className="grid mx-5 mb-12">
                        <div className="grid grid-cols-1 md:grid-rows-1 md:grid-cols-4">
                            <div className="flex flex-col  border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        1
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Evaluation
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        We schedule sessions to determine your business goals and
                                        strategic requirements
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8 hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        2
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Team assembly
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        We assemble a team from our rich resource pool of highly
                                        skilled dedicated software engineers
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        3
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Project kick-off
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        Your team starts working for you with maximum competency
                                        from day one
                                    </p>
                                </div>
                            </div>

                            <div className="flex flex-col border-l md:border-r border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        4
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Scale up
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        Your product grows and so does your team - seamlessly. We
                                        can scale up readily and consistently
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid mx-5 md:mx-16">
                        <div className="flex flex-col">
                            <div className="mb-12 flex flex-row">
                                <div className="">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/NDA.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        NDA covered if needed
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Any special subtleties can be covered in an NDA, and the
                                        customer retains complete IP rights.
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12 mx-auto">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/Fulltransparency-test.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Full transparency
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Our team follows a unique delivery framework: consistent,
                                        predictable, and transparent. We give you more information
                                        and provide full visibility at all times.
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12 mx-auto">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/kick.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Reduce Overhead
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Forget the painstaking processes of hiring and managing
                                        resources, let alone the cost of all of it! We hire the best
                                        talents in the industry and maintain a rich pool of skilled
                                        resources to meet any augmentation demands.
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12 mx-auto">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/Lowturn.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Low turnovers
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Our developers tend to stay in for the long haul. This
                                        limits the possibilities of staff changes on your project
                                        and the need to constantly onboard new people.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="w-full pt-9 md:pt-28" id="Development">
                <div className="grid mid-home-column">
                    <div className="pb-9 md:pb-20 items-center flex flex-col mx-5">
                        <h2 className="pb-1 text-black font-headline break-words text-center font-extrabold text-4xl">
                            End-To-End Development
                        </h2>
                        <p className="text-center break-words font-body text-xl font-normal text-gray-600">
                            Realize your dream projects - readily and efficiently
                        </p>
                    </div>
                    <div className="grid mx-5 mb-12">
                        <div className="grid grid-cols-1 md:grid-rows-1 md:grid-cols-4">
                            <div className="flex flex-col border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        1
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Set goals
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        After the discovery, we conduct a detailed research and set
                                        the roadmap towards a common goal
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        2
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Design
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        Our skillful design team helps you visualize and prototype
                                        your project at a very early stage
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col border-l border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        3
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Develop & test
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        We start development with you having the full control and
                                        the ability to move back and forth easily
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-col border-l md:border-r border-indigo-100">
                                <div
                                    className="p-9 hover:pl-8  hover:border-l-4 border-indigo-100 hover:border-blue-500">
                                    <h1 className="mb-6 font-body text-6xl font-semibold text-blue-500">
                                        4
                                    </h1>
                                    <p className="font-body text-xl font-extrabold mb-2">
                                        Support
                                    </p>
                                    <p className="font-body text-base font-medium text-gray-600">
                                        We stay with you as long as you need our assistance even
                                        after the project completion
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="grid mx-5 md:mx-16">
                        <div className="flex flex-col">
                            <div className="mb-12 flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/ownership.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Ownership
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        We take project ownership and responsibility for decisions
                                        that were taken during the development
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/Commitment.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Commitment to results
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        The success of your projects is the only metric that really
                                        matters to us
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/focusonsuccess.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Focus on your success
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Our business strategy is simple: if our customers' business
                                        is booming, we are growing too
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/communication.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Communication
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        We highly advocate industry proven Scrum development which
                                        allows us to ensure our clients have full control over the
                                        process.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="w-full py-9 md:py-28" id="Consultancy">
                <div className="grid mid-home-column">
                    <div className="pb-12 items-center flex flex-col mx-5 md:mx-16">
                        <h2 className="pb-1 font-headline break-words text-center font-extrabold text-4xl">
                            Consultancy
                        </h2>
                        <p className="text-center break-words font-body text-xl font-normal text-gray-600">
                            Harness global resources, bridge the knowledge gap
                        </p>
                        <p className="mt-9 md:mt-20 font-body text-base font-normal text-gray-600">
                            If you are looking for a mentor or a small team of experienced
                            senior professionals who can lead your team to your desired goal -
                            DSi is happy to lend you a hand. Here in DSi, we have industry
                            leading brains who are extremely adept at solving complex
                            problems. Our seasoned professionals have extensive experience in
                            solving problems regarding scalability or performance in large
                            scale applications for the government or other IT companies. Just
                            let us know your challenge and we will arrange a meeting for you
                            with our specific expert in that domain.
                        </p>
                    </div>
                    <div className="grid mx-5 md:mx-16">
                        <div className="flex flex-col">
                            <div className="mb-12 flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/software-Architecture.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Software Architecture
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        This is our strong suit. We have already built multiple
                                        government level projects with highly scalable, distributed
                                        and fault tolerant architecture designed by our in-house
                                        experts
                                    </p>
                                </div>
                            </div>
                            <div className="mb-12 flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/Development-Strategy.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Development Strategy
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Developing software for more than two decades we had enough
                                        time to try out many available software development
                                        strategies and figured out our way to the most nimble and
                                        fail-safe one. You can just keep your existing engineering
                                        team and hire the lead engineers from us to max out the
                                        performance
                                    </p>
                                </div>
                            </div>
                            <div className="flex flex-row">
                                <div className="w-12">
                                    <Image
                                        alt="works photo"
                                        src="/images/work/Scalability.svg"
                                        width="48"
                                        height="42"
                                        layout="fixed"
                                        objectFit="fill"
                                        loading="lazy"
                                    />
                                </div>
                                <div className="flex flex-col ml-6">
                                    <p className="font-body text-2xl font-extrabold mb-2">
                                        Scalability
                                    </p>
                                    <p className="font-body text-base font-normal text-gray-600">
                                        Business is booming all of a sudden? It’s quite to normal if
                                        your software is struggling to keep up with the demand. We
                                        specialize in re-structuring and optimizing for smooth
                                        scalability. Reach out to us to get a consultant looking
                                        into your scalability needs.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Work;
